module.exports = __webpack_public_path__ + "static/img/picture.edd97f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture.png
// module id = cUYT
// module chunks = 62